<app-introduction-message></app-introduction-message>
<app-navbar></app-navbar>
<app-automatic-update></app-automatic-update>

<router-outlet></router-outlet>
